import React, { useCallback, useContext } from 'react';
import { IEditPortionContext, EditPortionContext } from '../editPortionState/editPortionContext';
import ModalSentError from 'components/ModalWindows/ModalSentError';
import classNames from 'classnames';
import style from './ModalWindows.module.scss';

interface IProps {
	onCloseModal: () => void;
}

export const ModalWindows: React.FC<IProps> = () => {
	const { changeTypeOfModalWindow, typeOfModalWindow } = useContext<IEditPortionContext>(EditPortionContext);
	const containerClasses = classNames(style.container, { [style.visible]: typeOfModalWindow });

	const handleCloseModal = useCallback(() => {
		changeTypeOfModalWindow(null);
	}, []);

	return (
		<div className={containerClasses} data-test="ModalWindows">
			{typeOfModalWindow === 'defaultTranslationIsEmpty' && (
				<ModalSentError
					onConsentEvent={handleCloseModal}
					isVisible={true}
					description="errorDefaultTranslationOnBlock"
				/>
			)}
		</div>
	);
};
